<div class="d-flex justify-content-between dialog-title">
  <div>
    <p class="mb-0 mt-1 fs-6 dialog-title">{{ data.title }}</p>
  </div>
  <div>
    <button [mat-dialog-close]="true" mat-icon-button>
      <mat-icon class="dialog-icon">close</mat-icon>
    </button>
  </div>
</div>
<hr>

  <form [formGroup]="addToCartForm">
    <div mat-dialog-content>
      <div class="d-flex">
        <div class="w-100">
          <nz-form-item>
            <div class="w-100">
              <nz-form-label nzRequired>Item Quantity</nz-form-label>
              <nz-form-control nzErrorTip="Item Quantity is required!">
                <nz-input-number class="w-100" formControlName="itemQuantity"
                nzPlaceHolder="Enter item quantity"></nz-input-number>
              </nz-form-control>
            </div>
          </nz-form-item>
        </div>

        <div class="d-flex my-auto">
          <button class="mx-2" nz-button nzType="default" nzShape="circle" nzSize="large" (click)="onQty('up')"
            nz-tooltip nzTooltipTitle="Increase (↑ or +)">
            <em class="las la-plus"></em>
          </button>
          <div>
            <button nz-button nzType="default" nzShape="circle" nzSize="large" (click)="onQty('down')"
              nz-tooltip nzTooltipTitle="Decrease (↓ or -)">
              <em class="las la-minus"></em>
            </button>
          </div>
        </div>
      </div>
      <div>
        <label nz-checkbox formControlName="isServiceCharge">Service Charge Available</label>
      </div>
      <nz-form-item>
        <div class="w-100">
          <nz-form-label nzRequired>Select Size</nz-form-label>
          <nz-form-control nzErrorTip="Select Size is required!">
            <nz-select nzShowSearch formControlName="foodQuantityTagId" class="w-100"
              nzPlaceHolder="Select Size">
              @for (data of filteredFoodItemQuantityKeyValue; track data) {
                <nz-option [nzLabel]="data.value"
                  [nzValue]="data.key">
                </nz-option>
              }
            </nz-select>
          </nz-form-control>
        </div>
      </nz-form-item>

      <div class="row">
        @for (extra of data.foodItem.foodExtras; track extra) {
          <div class="col-4 mb-2">
            @if (extra.imageUrl) {
              <div class="image-container cursor" [ngClass]="{'selected': selectedExtra.has(extra.id)}"
                   (click)="onExtraSelectionChange(extra.id)">
                <img [src]="extra.imageUrl" alt="extra" class="extra-image"/>
                <div class="name-label" [ngClass]="{'selected-label': selectedExtra.has(extra.id)}">
                  {{ extra.name }}
                </div>
              </div>
            } @else {
              <div class="food-box text-center cursor" [ngClass]="{'selected': selectedExtra.has(extra.id)}" (click)="onExtraSelectionChange(extra.id)">
                <p class="mb-0">{{ extra.name }}</p>
              </div>
            }
          </div>
  }
</div>


<nz-form-item>
  <div class="w-100">
    <nz-form-label>Kitchen Instruction</nz-form-label>
    <nz-form-control>
      <textarea nz-input formControlName="kitchenInstruction" type="text"
      placeholder="Enter kitchen instruction"></textarea>
    </nz-form-control>
  </div>
</nz-form-item>
</div>

<div class="mt-4 d-flex justify-content-end mb-4 me-4">
  <button class="small-btn-width btn-radius me-2" [mat-dialog-close]="true" nzType="primary" nzGhost nz-button
    nz-tooltip nzTooltipTitle="Cancel (Esc)">
    Cancel
  </button>
  <button nz-button nzType="primary" class="btn-radius" (click)="onSubmit()"
    nz-tooltip nzTooltipTitle="Submit (Enter)">
    {{ data.btnTitle }}
  </button>
</div>
</form>
